import RestService from "../services/rest.service";

export const getResultData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/evaluate/360/${data}/result`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const getResultDataAdmin = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    RestService.get(`app/kpi/evaluate/360/${data}/result?type=view`).then(
      (response) => {
        let data = response.data.data
        resolve(data)
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}

export const submitAndSignOff = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let postData = {
      form_evaluate_id: data
    }
    RestService.post(`app/kpi/evaluate/360/submit`, postData).then(
      (response) => {
        resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        dispatch({
          type: "SET_MESSAGE",
          payload: message,
        });
        reject()
      }
    )
  })
}